<template>
  <Layout id="app">
    <Header class="sys-header" v-show="sys.isLogin">
      <pi-header
        :menuId="menuId"
        v-if="sys.isLogin"
        :isLogin="sys.isLogin"
      ></pi-header>
    </Header>
    <Layout class="app-layout">
      <Sider hide-trigger class="sys-nav" v-show="sys.isLogin && !isHome">
        <pi-menu
          :menuId="menuId"
          :isCollapse="isCollapse"
          @collapse="isCollapse = !isCollapse"
          v-if="sys.isLogin && !isHome"
        ></pi-menu>
      </Sider>
      <Content>
        <sys-content-header v-show="sys.isLogin"></sys-content-header>
        <div class="router-content" :class="{ 'login-p': !sys.isLogin }">
          <router-view />
          <Spin size="large" fix v-if="sys.pageLoading"></Spin>
        </div>
      </Content>
    </Layout>
  </Layout>
</template>
<script>
import Header from "./components/header/hearer";
import Menu from "./components/menu/menu";
import SysContentHeader from "./components/sys-content-header/sys-content-header";
// import divScroll from "./components/div-scroll/div-scroll.vue";
import { mapState, mapMutations } from "vuex";
import igreenIco from "./assets/ico/igreen.png";
import esproIco from "./assets/ico/espro.png";
export default {
  name: "app",
  data() {
    return {
      menuId: "",
      isCollapse: false,
      isHome: false,
      ico: {
        "CSE Merchant Platform": igreenIco,
        "ESPRO Merchant Platform": esproIco
      }
    };
  },
  methods: {
    thatUrl(to) {
      if (to) {
        if (to.matched[0]) {
          const name = to.matched[0].components.default.name;
          const routerTag = {
            url: to.path,
            name: to.name,
            componentsName: name,
            mainIdex: to.meta && to.meta.mainPage ? true : false,
            currentLanguageName:
              to.meta && to.meta.menuData
                ? to.meta.menuData.currentLanguageName
                : ""
          };
          if (routerTag.url !== "/login") {
            this.SET_GOROUTER(routerTag);
          }
        }
        if (to.path.indexOf("/home") != -1 || to.path == "/") {
          this.isHome = true;
        } else {
          this.isHome = false;
        }
        if (to.meta.menuData) {
          this.menuId = to.meta.menuData.menuIndex;
        }
        const data = to.meta;
        data.fullPath = to.fullPath;
        data.name = to.name;
        this.SET_TODATE(to.meta);
      }
    },
    ...mapMutations(["SET_GOROUTER", "SET_TODATE"])
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: "thatUrl"
  },
  created() {
    // if (!this.$config.languageShow) {
    //   localStorage.setItem("language", "zh-CN");
    // }
    // if (this.$config.defaultOprTitle) {
    //   document.title = this.$config.defaultOprTitle;
    // }
  },
  mounted() {
    const link = document.querySelector('link[rel*="icon"]');
    if (link) {
      link.setAttribute("href", this.ico[process.env.VUE_APP_TITLE]);
    }
    this.thatUrl(this.$route);
  },
  components: {
    "pi-header": Header,
    "pi-menu": Menu,
    "sys-content-header": SysContentHeader
    // "pi-div-scroll": divScroll
  },
  computed: {
    ...mapState(["sys"])
  }
};
</script>

<style lang="less">
#app {
  .router-content {
    flex: 1;
    position: relative;
    background: #fff;
    // padding: 0.2rem 0.2rem;
    background: #edeef7;
    overflow-y: auto;
  }
  .router-content.login-p {
    padding: 0;
  }
  .ivu-layout-content {
    background: #eef0f5;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .app-layout {
    overflow: hidden;
  }
}
.ivu-layout-header.sys-header {
  background: transparent !important;
  position: relative;
  height: 0.6rem !important;
  z-index: 5;
  padding: 0;
}
.ivu-layout-sider {
  transition: all 0.1s ease-in-out;
}
.ivu-layout-sider.sys-nav {
  width: 2.2rem !important;
  min-width: 2.2rem !important;
  max-width: 2.2rem !important;
  flex: 0 0 2.2rem !important;
  background: #fff !important;
  position: relative;
  overflow-y: auto;
}
.ivu-layout-sider.sys-nav-small {
  width: 2rem !important;
  min-width: 2rem !important;
  max-width: 2rem !important;
  flex: 0 0 2rem !important;
  background: #fff !important;
  position: relative;
  box-shadow: 1px 1px 2px 0px rgba(153, 153, 153, 0.5);
}
.ivu-layout-footer.sys-footer {
  padding: 0;
  text-align: center;
  color: #999999;
  font-size: 0.12rem;
  height: 0.16rem;
  line-height: 0.16rem;
}
.menu-small-width {
  width: 0.5rem;
}
</style>
